/**
 * As cores e as escalas dos gráficos, lidas das MESMAS variáveis CSS do resto da aplicação.
 *
 * Nenhuma cor literal mora aqui: um gráfico com paleta própria é um pedaço da tela que não muda
 * quando o tema muda, e a primeira coisa que se nota nele é que ele não pertence ali.
 */

/** A cor de destaque — a mesma do link e do foco. Usada quando a série é UMA. */
export const COR_PRINCIPAL = 'var(--accent)';

/**
 * A rampa para séries categóricas. Poucas cores de propósito: um gráfico que precisa de doze
 * cores distinguíveis está pedindo para ser uma tabela, e a rampa dá a volta em vez de inventar
 * tons que ninguém separa a olho.
 */
export const RAMPA = [
  'var(--accent)',
  '#4e9bf5',
  '#3fbf7f',
  '#d99b2b',
  '#a06ee0',
  '#2fb8b0',
] as const;

export const corDaSerie = (i: number): string => RAMPA[i % RAMPA.length];

/** Cinza para o que não se agrupa — nunca uma cor viva, que competiria com o que importa. */
export const COR_NEUTRA = 'var(--text-tertiary)';

/**
 * A largura da barra, em porcentagem do maior valor da série.
 *
 * Proporcional ao MAIOR e não ao total: numa lista de concentração, o segundo colocado com metade
 * do primeiro precisa ocupar metade da barra para a comparação ser lida de relance. Com o total
 * como base, seis itens de 15% cada virariam seis tracinhos indistinguíveis.
 */
export function largura(valor: number, maior: number): string {
  if (!Number.isFinite(valor) || !Number.isFinite(maior) || maior <= 0) return '0%';
  const p = Math.max(0, Math.min(100, (valor / maior) * 100));
  // Um mínimo visível: uma barra de 0,2% que não aparece faz o item parecer ausente, e ausência
  // e quase-zero são coisas diferentes numa investigação.
  return `${p > 0 ? Math.max(p, 1.5) : 0}%`;
}

export const reais = (v: number, casas = 0): string =>
  v.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: casas,
  });

export const pct = (v: number, casas = 1): string =>
  `${v.toLocaleString('pt-BR', { maximumFractionDigits: casas })}%`;

export const numero = (v: number): string => v.toLocaleString('pt-BR');
